var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('van-empty',{attrs:{"description":"sorry 小易没有找到您要的东西 ~~"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }